import { Override, Model, ObjectHelper } from "@bryntum/schedulerpro";

Override.apply(
  class ModelOverride {
    static target = {
      class: Model,
      // Bug is present in all versions at the moment, can't set highest version yet
      minVersion: "7.2.0",
      maxVersion: "7.3.8",
      product: "schedulerpro"
    };

    internalClearChanges(includeDescendants = true, removeFromStoreChanges = true, changes = null, clearNonPersistable = false) {
      const me = this,
        { meta } = me;

      // If we've received an object with changes, we only need to clean that one up
      if (changes) {
        const { modified } = meta;

        for (const key in changes) {
          delete modified[key];
        }

        for (const key in modified) {
          const field = me.getFieldDefinition(key);

          if (
            // If there's a store field modified, we won't receive those changes here. So instead we need to go
            // over modified fields, find their backing stores and remove those keys if stores' changes are null
            // (meta.modified holds the field's original value, so the store is resolved via the field)
            (field?.isStoreDataField && me.meta[`${key}Store`] && !me.meta[`${key}Store`].changes) ||
            // Remove non-persistable fields
            (clearNonPersistable && !field?.persist)
          ) {
            delete modified[key];
          }
        }
      } else {
        // for remote changes, we clear the old changes and apply only the changes made
        // during the record's materialization
        meta.modified = { ...meta.modifiedMaterialized };
        meta.modifiedMaterialized = null;

        // Accepting all changes on the record includes the stores backing its store type fields -
        // their own change bags are the field's dirty state (the source of truth in granular mode,
        // where a stale bag would resurrect the field's modified marker on the store's next change)
        for (const field of me.constructor.$meta.fields.initable ?? []) {
          if (field.isStoreDataField) {
            meta[`${field.name}Store`]?.acceptChanges();
          }
        }
      }

      // We can only remove the record from the store´s "modified" bag if there are no modified fields in meta
      const noChanges = ObjectHelper.isEmpty(meta.modified);

      meta.committing = false;

      if (removeFromStoreChanges) {
        me.stores?.forEach((store) => {
          noChanges && store.modified.remove(me);
          store.added.remove(me);
          // OVERRIDE
          // if record has an ID now and still has some modified keys, add it to the modified store bag
          if (!me.isPhantom && Object.keys(me.meta.modified).length > 0) {
            store.modified.add(me);
          }
          if (includeDescendants) {
            const descendants = store.collectDescendants(me).all;
            store.added.remove(descendants);
            noChanges && store.modified.remove(descendants);
          }
        });
      }
    }
  }
);